// @flow
import React, { Component } from 'react';
import Modal from '../../components/modal';
import AuthScreenLayout from '../../components/auth-page-layout';
import Input from '../../components/auth-page-layout/input';
import GraphQLErrors from '../../components/graphql-errors';
import Button, { PROGRESS_STATE } from '../../components/button/progress';
import { Form } from './login.styles';
import login from './graphql';

type Props = {};

class LoginPage extends Component {
  state = {
    isLoading: false,
    progressState: PROGRESS_STATE.NOTHING,
  };

  handleSubmit = async e => {
    e.preventDefault();
    try {
      const data = new FormData(e.target);
      const email = data.get('email');
      const password = data.get('password');
      this.setState({ progressState: PROGRESS_STATE.LOADING, error: null });
      const { data: { jwt } } = await this.props.login({
        variables: { email, password },
      });
      localStorage.setItem('jwt', jwt);
      window.mixpanel.track('Login', { email });
      this.props.history.push('/');
    } catch (error) {
      if (
        error.graphQLErrors.some(({ message }) => message === 'USER_INAVTIVE')
      ) {
        this.setState({ progressState: PROGRESS_STATE.NOTHING });
        this.modal.show();
      } else {
        this.setState({ progressState: PROGRESS_STATE.ERROR, error });
      }
    }
  };

  props: Props;

  render() {
    const { state } = this;
    return (
      <AuthScreenLayout
        footerLinkText="Don't have an account? Create one."
        footerLinkURL="/signup"
      >
        <Form onSubmit={this.handleSubmit}>
          <Input name="email" placeholder="Enter your email" type="email" />
          <Input name="password" placeholder="Password" type="password" />
          <Button
            state={state.progressState}
            disabled={state.progressState === PROGRESS_STATE.LOADING}
          >
            {state.isLoading ? 'Loading' : 'Login'}
          </Button>
          <GraphQLErrors error={state.error} />
        </Form>
        <Modal
          title="Sorry for the wait!"
          content="You are still in the queue, we'll email you as soon as we have enough space and can activate your account."
          onClose={() => this.modal.hide()}
          innerRef={ref => {
            this.modal = ref;
          }}
        />
      </AuthScreenLayout>
    );
  }
}

export default login(LoginPage);



// WEBPACK FOOTER //
// ./src/pages/login/index.js